export const domain = "https://api.industrialparts.co.ug"
//export const domain = "http://127.0.0.1:8000"